import axios from '../axios'

// 講師返信の既読化
const postFeedbackReadApi = async () => {
  return await axios.post('api/lms/feedback/read')
}

export default postFeedbackReadApi
